import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import ProductCard from "./ProductCard";

function ProductSection({
  title,
  sectionIdx,
  products,
  enablePagination = false,
  pagination,
  onViewMore,
  initialLimit = 5,
}) {
  const navigate = useNavigate();
  const [limit, setLimit] = useState(initialLimit);

  const allProducts = useMemo(
    () => (products?.filter((item) => item?.title) || []),
    [products]
  );

  const sectionProducts = useMemo(
    () => {
      if (!enablePagination) return allProducts.slice(0, Math.max(4, limit));
      return allProducts;
    },
    [allProducts, enablePagination, limit]
  );

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
      <div className="flex items-center justify-between gap-3">
        <h2 className="text-base font-extrabold text-[#24303A]">{title}</h2>
        {enablePagination ? (
          <div className="flex items-center gap-2 text-xs">
            <button
              type="button"
              disabled={!pagination?.hasPrev || pagination?.loading}
              onClick={pagination?.onPrev}
              className="rounded-full border border-slate-200 bg-white px-3 py-1.5 font-semibold text-slate-700 disabled:opacity-50 shadow-sm"
            >
              Prev
            </button>
            <span className="text-slate-500">
              Page {pagination?.page ?? 1}
            </span>
            <button
              type="button"
              disabled={!pagination?.hasNext || pagination?.loading}
              onClick={pagination?.onNext}
              className="rounded-full bg-[#7352C7] px-3 py-1.5 font-semibold text-white disabled:opacity-50 shadow-sm"
            >
              Next →
            </button>
          </div>
        ) : (typeof onViewMore === "function" || allProducts.length > sectionProducts.length) ? (
          <button
            type="button"
            onClick={() => {
              if (typeof onViewMore === "function") {
                onViewMore();
                return;
              }
              setLimit((v) => v + 10);
            }}
            className="rounded-full bg-[#7352C7] px-4 py-2 text-xs font-semibold text-white hover:bg-[#6546c3] shadow-sm"
          >
            View All →
          </button>
        ) : null}
      </div>

      <div className="mt-4 grid gap-4 sm:grid-cols-2 md:grid-cols-5">
        {sectionProducts.map((product, idx) => (
          <ProductCard
            key={idx}
            product={product}
            accent={["orange", "blue", "green", "purple"][(sectionIdx + idx) % 4]}
            showComparison={
              title === "Today's Top Deals" || title === "Features Products"
            }
            retailerLabel={
              title === "Tesco Products"
                ? "Tesco"
                : title === "Morrisons Products"
                ? "Morrisons"
                : title === "ASDA Products"
                ? "ASDA"
                : title === "Sainsbury's Products"
                ? "Sainsbury's"
                : undefined
            }
            onClick={() =>
              navigate(
                `/product/${encodeURIComponent(
                  product.product_id || product.pid || product.sku
                )}`
              )
            }
          />
        ))}
      </div>
    </div>
  );
}

export default ProductSection;